export enum Routes {
  FleetFireExtinguisherRouter = "*",
  FireExtinguisherSearchPageRouter = "/fleet/fire-extinguisher/search",
}
